import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

export default function Deployments() {
  const [cases, setCases] = useState([]);
  useEffect(() => {
    api.get("/case-studies").then(({ data }) => setCases(data)).catch(() => {});
  }, []);

  return (
    <section data-testid="deployments-section" className="px-6 md:px-14 py-24 md:py-32 border-b border-[#2A2A2A]">
      <div className="max-w-6xl">
        <div className="text-overline mb-6">◢ Scenarios over slogans</div>
        <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl text-white leading-[1.05]">
          Real-world <span className="text-[#FF4500]">deployments</span>.
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="deployment-grid">
        {cases.map((c, i) => (
          <article
            key={c.id}
            data-testid={`case-${c.id}`}
            className="ww-card p-6 md:p-8 group ww-trace"
          >
            <div className="flex items-start justify-between gap-4">
              <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#DFFF00]">{c.industry}</span>
              <span className="font-mono text-[10px] text-[#555]">CASE / {String(i + 1).padStart(2, "0")}</span>
            </div>

            <h3 className="mt-5 font-display text-2xl md:text-3xl text-white">{c.title}</h3>

            <div className="mt-5 space-y-4 text-sm">
              <Field label="Problem"  body={c.problem} />
              <Field label="Solution" body={c.solution} />
              <Field label="Outcome"  body={c.outcome} accent />
            </div>

            <div className="mt-6 flex flex-wrap gap-2">
              {c.tech.map((t) => (
                <span key={t} className="ww-chip text-[10px]">{t}</span>
              ))}
            </div>

            {c.impact_metrics?.length > 0 && (
              <div className="mt-6 grid grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
                {c.impact_metrics.map((m, idx) => (
                  <div key={idx} className="bg-[#0a0a0a] p-4">
                    <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8E8E93]">{m.label}</div>
                    <div className="font-display font-bold text-2xl text-white mt-1">{m.value}</div>
                  </div>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>

      <div className="mt-12">
        <Link to="/playbooks" data-testid="see-playbooks" className="btn-secondary">View use-case playbooks →</Link>
      </div>
    </section>
  );
}

function Field({ label, body, accent = false }) {
  return (
    <div>
      <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#8E8E93]">{label}</div>
      <p className={`mt-1.5 leading-relaxed ${accent ? "text-white" : "text-[#D7D7D9]"}`}>{body}</p>
    </div>
  );
}
